import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";

const Shell = ({ children }) => (
  <div className="grid min-h-screen lg:grid-cols-2">
    <div className="relative hidden overflow-hidden lg:flex">
      <img src="/images/custom_home_estate.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#0E1F3F]/60" />
      <div className="relative mt-auto p-12 text-white">
        <p className="eyebrow mb-3 !text-[#F2B91C]">Firm Foundations Construction</p>
        <p className="font-display text-4xl font-bold leading-tight">Your project, always in view.</p>
        <p className="mt-3 max-w-md text-white/75">Customers see progress, estimates and invoices. Our crew clocks in and tracks tasks.</p>
      </div>
    </div>
    <div className="flex flex-col items-center justify-center gap-6 px-4 py-10">
      <Link to="/" data-testid="auth-back-home" className="font-display text-lg font-bold">← Firm Foundations</Link>
      {children}
    </div>
  </div>
);

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/portal" /></Shell>
);

export const SignUpPage = () => (
  <Shell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/portal" /></Shell>
);
